//   const onSubmit = async () => {
//     const isValid = await trigger();
//     if (isValid) {
//       setshowerror(false);
//       const data = getValues();
//       console.log(data);
//       const code = data.inputs.join("");
//       if (code) {
//         const res = await api.updateactivationcode('activationCode=' + code );
//         if (res.hasError === false) {
//           setShowActivation(true);
//         }
//         else if (res.hasError === true && res.message === "Error: Unauthorized user") {
//           setshowerror(true);
//           setErrorMessage("The user is not allowed to perform this task")
//           setShowActivation(false);
//         }
//         else{
//           setshowerror(true);
//           setErrorMessage("The activation code is not valid.")
//           setShowActivation(false);
//         }

//       }
//     }
//   };
export function findUniqueCharacter(value: string, str: string) {
  // If either string is empty, return the non-empty string
  if (value === "") {
    return str;
  } else if (str === "") {
    return "";
  }

  const charCount: { [key: string]: number } = {};

  // Count characters in the first string
  for (const char of value) {
    charCount[char] = (charCount[char] || 0) + 1;
  }

  // Count characters in the second string
  for (const char of str) {
    charCount[char] = (charCount[char] || 0) + 1;
  }

  const singleUniqueChars: string[] = [];
  const doubleUniqueChars: string[] = [];

  // Check for unique characters
  for (const [char, count] of Object.entries(charCount)) {
    if (count === 1) {
      singleUniqueChars.push(char);
    } else if (count === 2) {
      doubleUniqueChars.push(char);
    }
  }

  // Return single unique character if found
  if (singleUniqueChars.length > 0) {
    return singleUniqueChars[0] as string;
  }
  // If no single unique character found, return the pair of unique characters
  else if (doubleUniqueChars.length > 0) {
    return doubleUniqueChars[0] as string;
  }
  // If no unique characters found at all, return value
  else {
    return value;
  }
}
